runMergeFunction